import { game } from '../main';
import { Popup } from './Popup';
import { createMultiLineText } from '../Components/MultiLineText';
import { OneLineText, createOneLineText } from '../Components/OneLineText';
import { playSound } from '../handlers/playSound';
import { makeImage } from '../utils/makeImage';
import { GameState } from '../states/GameState';

declare const GBCXPromo;

interface IPopupGameOverConfig {
  won: boolean;
  score: number;
  bonusScore: number;
  bubblesPopped: number;
};

export class PopupGameOver extends Popup {
  constructor({won, score, bonusScore, bubblesPopped}: IPopupGameOverConfig) {
    super();
    const total = score + bonusScore;

    // var winEvent = "Complete";
    // var loseEvent =  "Fail";
    // sdkHandler.trigger("gameTracking", {
    //   event: won ? winEvent : loseEvent,
    //   dimension1: "GameMode"
    // });

    playSound(won ? 'won' : 'lost');

    this.addTitle(game.getText(16));

    this.add(this.makeGameOverPosition(0, -150, game.getText(24), bubblesPopped));
    this.add(this.makeGameOverPosition(0, -80, game.getText(17), score));
    this.add(this.makeGameOverPosition(0, -10, game.getText(18), bonusScore));
    this.add(this.makeGameOverPosition(0, 60, game.getText(19), total, true));

    this.addButton(0, 280, 'button_big', game.getText(5), () => {
      game.state.start(GameState.key);
      GBCXPromo.gameStart();
    });
  }

  private makeGameOverPosition(
    x: number,
    y: number,
    labelText: string,
    amount: number,
    tinted: boolean = false,
  ): Phaser.Group {
    const group = game.make.group();
    group.position.setTo(x, y);

    const bg = makeImage(0, 0, 'bg_numbers_big', 0.5, group);

    const label = createMultiLineText(-140, 0, 'font', labelText, 20, 170, 50, 'center', 0.5, 0.5);
    // @ts-ignore
    label.updateCache();
    group.add(label);

    const value = createOneLineText(95, 0, 'font', amount.toString(), 25, 270, 0.5, 0.5);
    group.add(value);

    if (tinted) {
      label.tint = 0xffcc00;
      // @ts-ignore
      label.updateCache();
      value.tint = 0xffcc00;
      // @ts-ignore
      value.updateCache();
    }

    return group;
  }
}